const BASE = '/hub-v2/bookkeeping';

const routes = {
    base: BASE,

    // Member Books
    memberBooks: {
        root: `${BASE}/member-books`,
        list: `${BASE}/member-books`,
        member: (memberId: string | number) => `${BASE}/member-books/members/${memberId}`,
        reviewTransactions: (memberId: string | number) =>
            `${BASE}/member-books/members/${memberId}/review/transactions`,
        reconcileAccounts: (memberId: string | number) => `${BASE}/member-books/members/${memberId}/reconcile/accounts`,
        reconcileClosings: (memberId: string | number) => `${BASE}/member-books/members/${memberId}/reconcile/closings`,
        closingDetails: (memberId: string | number, closingId: string) =>
            `${BASE}/member-books/members/${memberId}/reconcile/closings/${closingId}`,
        reconciliation: (memberId: string | number, closingId: string) =>
            `${BASE}/member-books/members/${memberId}/reconcile/closings/${closingId}/transactions`,
        categorizeTransactions: (memberId: string | number) =>
            `${BASE}/member-books/members/${memberId}/categorize/transactions`,
        categorizeExpenses: (memberId: string | number) =>
            `${BASE}/member-books/members/${memberId}/categorize/expenses`,
        categorizeIncome: (memberId: string | number) => `${BASE}/member-books/members/${memberId}/categorize/income`,
        reportsAll: (memberId: string | number) => `${BASE}/member-books/members/${memberId}/reports/all`,
        reportsProfitLoss: (memberId: string | number) =>
            `${BASE}/member-books/members/${memberId}/reports/profit-loss`,
        reportsBalanceSheet: (memberId: string | number) =>
            `${BASE}/member-books/members/${memberId}/reports/balance-sheet`,
        reportsCashFlow: (memberId: string | number) =>
            `${BASE}/member-books/members/${memberId}/reports/cash-flow-statement`,
        reportsTrialBalance: (memberId: string | number) =>
            `${BASE}/member-books/members/${memberId}/reports/trial-balance`,
        generalLedger: (memberId: string | number) =>
            `${BASE}/member-books/members/${memberId}/accounting/general-ledger`,
    },

    // Accountant V2
    accountantV2: {
        root: `${BASE}/accountant-v2`,
        queue: `${BASE}/accountant-v2/queue`,
    },

    // Dashboard
    dashboard: {
        root: `${BASE}/dashboard`,
    },

    // Investigate (missing transactions)
    investigate: {
        root: `${BASE}/investigate`,
    },

    // Transaction Extraction (statement OCR citation review). Queue only — the review workspace is
    // registered in the shared operator-task dispatcher and lives at
    // /hub-v2/operator-task/:taskId/member/:memberId like every other task-backed workspace.
    transactionExtraction: {
        root: `${BASE}/transaction-extraction`,
        queue: `${BASE}/transaction-extraction/queue`,
    },

    // Year-End Closings
    yearEndClosings: {
        root: `${BASE}/year-end-closings`,
    },

    // Debug (accountant-only); add reports in debug/debugReports.config.ts
    debug: `${BASE}/debug`,
    debugReport: (reportId: string) => `${BASE}/debug/${reportId}`,

    // General
    notFound: '/not-found',
};

export default routes;
